import { render } from "./MyCourses.vue?vue&type=template&id=67efc2d1"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peter/projects/BhubCollege/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__